import { Palette, PaletteMode } from '@mui/material';

const contrastThreshold: Palette['contrastThreshold'] = 3;
const tonalOffset: Palette['tonalOffset'] = 0.2;
const mode: PaletteMode = 'light';

export default {
  common: {
    black: '#000000',
    white: '#ffffff'
  },
  mode,
  contrastThreshold,
  tonalOffset,
  primary: {
    main: '#FFFFFF'
  },
  secondary: {
    main: '#FFCC00'
  },
  error: {
    main: '#DA0505'
  },
  warning: {
    main: '#FFE538'
  },
  info: {
    main: '#F2F2F2'
  },
  success: {
    main: '#41A674',
    contrastText: '#74C800',
    light: '#B7FB56'
  },
  grey: {
    50: '#F9FBFA',
    100: '#C4C4C4',
    200: '#D9D9D9',
    300: '#8F9399',
    400: '#808080',
    500: '#999EA8',
    600: 'rgba(205, 207, 210, .3)',
    700: 'rgba(31, 34, 41, .3)',
    800: 'rgba(31, 34, 41, .5)',
    900: 'rgba(32, 34, 41, .7)',
    A100: '#202229',
    A200: '#acb4c1',
    A400: '#696f7b',
    A700: '#141416'
  },
  divider: '#E9E8EE',
  text: {
    primary: '#FFFFFF',
    secondary: '#001133'
  },
  background: {
    default: '#ffffff'
  }
} as Omit<Palette, 'getContrastText' | 'augmentColor' | 'action'>;
